import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateUser } from "../../api/apiUsers";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لتحديث مستخدم
 */
export function useUpdateUser() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateUserMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateUser(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["users"] });
            navigate('/users');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update user");
        },
    });

    return {
        updateUserMutate,
        isPending,
    };
}